// The order a run's stops are shown in on the Transport board: active stops in their planned order, then any failed (cancelled)
// stops last (VehicleCard lists them the same way). The stop number on an entry card, and on that stop's dot on the map, is its
// position in this list, so the two always agree.
export const orderRunEntries = (entries) => [
  ...(entries || []).filter((e) => e.status !== 'failed'),
  ...(entries || []).filter((e) => e.status === 'failed'),
];
